import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Button from 'components/Button';
import HelixInfoModal from 'screens/HelixInfoModal';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
function HelixInfoButton() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showInfoModal = _useState2[0],
    setShowInfoModal = _useState2[1];
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Button, {
      variant: "transparent",
      size: "small",
      icon: "info",
      onClick: function onClick() {
        return setShowInfoModal(true);
      },
      children: t('property_helix_info')
    }), showInfoModal && /*#__PURE__*/_jsx(HelixInfoModal, {
      onClose: function onClose() {
        return setShowInfoModal(false);
      }
    })]
  });
}
export default HelixInfoButton;